<template>
  <div>
    <van-nav-bar
      title="数据可视化"
    />
    <van-dropdown-menu>
      <van-dropdown-item v-model="club" :options="clubs"/>
    </van-dropdown-menu>
    <van-cell title="选择日期区间" :value="date" @click="show = true"/>
    <van-calendar v-model="show" :min-date="minDate" :max-date="maxDate" type="range" @confirm="onConfirm"/>
    <div style="text-align: center;margin: 0 auto" id="myChart" :style="{width: width, height: height}"></div>
    <div style="text-align: center;margin: 0 auto" id="myChart2" :style="{width: width, height: height}"></div>

  </div>
</template>

<script>
import Vue from 'vue'
import {getClubList} from "network/club";
import {GetTrainingData, GetPhysicalTest} from "network/data_center";
import {
  NavBar, Calendar, CellGroup, Cell, DropdownMenu, DropdownItem
} from 'vant';

Vue.use(NavBar);
Vue.use(Calendar);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);

export default {
  name: "DataCenter",
  data() {
    return {
      // van calendar
      date: '',
      show: false,
      minDate: this.GLOBAL.start_select_time,
      maxDate: this.GLOBAL.end_select_time,
      // dropdown-menu
      club: 77,
      clubs: [],

      width: '0px',
      height: '0px',

      datas: [],
      dates: [],

      male: [],
      famale: [],
    }
  }, activated() {
    getClubList().then(res => {
        let clubs = [];
        for (let i = 0; i < res.length; i++) {
          clubs.push({text: res[i].title, value: res[i].id});
        }
        this.clubs = clubs;
      }
    )
    let a = 500 / 700;
    let width = document.documentElement.clientWidth;
    let height = document.documentElement.clientWidth * a;
    this.width = Math.floor(width) + 'px';
    this.height = Math.floor(height) + 'px';


    this.getPhysicalTest();
    setTimeout(() => {
      this.dataTable2();
    }, 1000)
  },
  methods: {
    async getPhysicalTest() {
      const res = await GetPhysicalTest();
      this.male = res.male;
      this.famale = res.famale;
    },
    formatDate(date) {
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      const [start, end] = date;
      this.show = false;
      this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
      GetTrainingData(this.club, start.getTime(), end.getTime()).then(res => {
        this.dates = res.date;
        this.datas = res.data;
      })
      setTimeout(() => {
        this.dataTable("预约数量");
      }, 1000)
    },
    dataTable(animal) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      let base = +new Date(1990, 9, 3);
      let oneDay = 24 * 3600 * 1000;
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          position: function (pt) {
            return [pt[0], '10%'];
          }
        },
        title: {
          left: 'center',
          text: animal
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            restore: {},
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.dates
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%']
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 10
          },
          {
            start: 0,
            end: 10
          }
        ],
        series: [
          {
            name: '训练人数',
            type: 'line',
            symbol: 'none',
            sampling: 'lttb',
            itemStyle: {
              color: 'rgb(255, 70, 131)'
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(255, 158, 68)'
                },
                {
                  offset: 1,
                  color: 'rgb(255, 70, 131)'
                }
              ])
            },
            data: this.datas
          }
        ]
      });
    },
    dataTable2() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart2'))
      // 绘制图表
      myChart.setOption({
        title: {
          text: 'Male and female height and weight distribution',
          subtext: 'Data from: HHSTU 2020'
        },
        grid: {
          left: '3%',
          right: '7%',
          bottom: '7%',
          containLabel: true
        },
        tooltip: {
          // trigger: 'axis',
          showDelay: 0,
          formatter: function (params) {
            if (params.value.length > 1) {
              return (
                params.seriesName +
                ' :<br/>' +
                params.value[0] +
                'cm ' +
                params.value[1] +
                'kg '
              );
            } else {
              return (
                params.seriesName +
                ' :<br/>' +
                params.name +
                ' : ' +
                params.value +
                'kg '
              );
            }
          },
          axisPointer: {
            show: true,
            type: 'cross',
            lineStyle: {
              type: 'dashed',
              width: 1
            }
          }
        },
        toolbox: {
          feature: {
            dataZoom: {},
            brush: {
              type: ['rect', 'polygon', 'clear']
            }
          }
        },
        brush: {},
        legend: {
          data: ['Female', 'Male'],
          left: 'center',
          bottom: 10
        },
        xAxis: [
          {
            type: 'value',
            scale: true,
            axisLabel: {
              formatter: '{value} cm'
            },
            splitLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            axisLabel: {
              formatter: '{value} kg'
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: 'Female',
            type: 'scatter',
            emphasis: {
              focus: 'series'
            },
            // prettier-ignore
            data: this.famale,
            markArea: {
              silent: true,
              itemStyle: {
                color: 'transparent',
                borderWidth: 1,
                borderType: 'dashed'
              },
              data: [
                [
                  {
                    name: 'Female Data Range',
                    xAxis: 'min',
                    yAxis: 'min'
                  },
                  {
                    xAxis: 'max',
                    yAxis: 'max'
                  }
                ]
              ]
            },
            markPoint: {
              data: [
                {type: 'max', name: 'Max'},
                {type: 'min', name: 'Min'}
              ]
            },
            markLine: {
              lineStyle: {
                type: 'solid'
              },
              data: [{type: 'average', name: 'AVG'}, {xAxis: 110}]
            }
          },
          {
            name: 'Male',
            type: 'scatter',
            emphasis: {
              focus: 'series'
            },
            // prettier-ignore
            data: this.male,
            markArea: {
              silent: true,
              itemStyle: {
                color: 'transparent',
                borderWidth: 1,
                borderType: 'dashed'
              },
              data: [
                [
                  {
                    name: 'Male Data Range',
                    xAxis: 'min',
                    yAxis: 'min'
                  },
                  {
                    xAxis: 'max',
                    yAxis: 'max'
                  }
                ]
              ]
            },
            markPoint: {
              data: [
                {type: 'max', name: 'Max'},
                {type: 'min', name: 'Min'}
              ]
            },
            markLine: {
              lineStyle: {
                type: 'solid'
              },
              data: [{type: 'average', name: 'Average'}, {xAxis: 170}]
            }
          }
        ]
      })
    }
  }
}
</script>

<style scoped>

</style>
